import React, { useState } from 'react';
import useOrderHistory from '../data/orderHistory';
import { Button, Modal, Input, Pagination, PageHeader, cn } from '../ui';
import AuthService from '../services/authentication'
import { useHistory } from 'react-router-dom';
import LoadingComponent from '../helpers/LoadingComponent';
import PrescriptionTable from './PrescriptionTable';
import CreateOrderForm from "../sales_orders/CreateOrderForm"

const TABS = [
  { key: 'all', label: 'All' },
  { key: 'completed', label: 'Completed' },
  { key: 'partial', label: 'Partial' },
  { key: 'unordered', label: 'Unordered' },
  { key: 'unsent', label: 'Unsent' },
];

function Prescriptions() {
  const [page, setPage] = useState(0);
  const [key, setKey] = useState('all');
  const [search, setSearch] = useState("");
  const [submittedSearch, setSubmittedSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  let auth = AuthService.useAuth()
  const { orders, total_count, isLoading, isError } = useOrderHistory(page, key, submittedSearch, auth.authHeader());
  const history = useHistory()
  const totalPages = Math.ceil(total_count / 20);

  const handleSearchChange = event => {
    setSearch(event.target.value);
  }

  const handleSearch = () => {
    setSubmittedSearch(search);
  }

  return (
    <div className="mx-auto w-full max-w-screen-xl px-4">
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create prescription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateOrderForm  />
        </Modal.Body>
      </Modal>
      <div className="flex w-1/2 mb-3">
        <Input
          type="text"
          placeholder="Search"
          value={search}
          onChange={handleSearchChange}
          className="me-2"
          onKeyPress={event => event.key === 'Enter' && handleSearch()}
        />
        <Button variant="secondary" onClick={handleSearch}>Search</Button>
      </div>
      <PageHeader
        title="Prescriptions"
        action={
          <Button variant="primary" onClick={() => setShowModal(true)}>
            Create new prescription
          </Button>
        }
      />
      <nav className="internal-nav flex gap-4 mb-2">
        {TABS.map(tab => (
          <button
            key={tab.key}
            type="button"
            onClick={() => { setPage(0); setKey(tab.key); }}
            className={cn(
              "pb-4 font-medium text-black",
              key === tab.key && "underline font-bold"
            )}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      {isLoading ? (
        <LoadingComponent />
      ) : isError ? (
        <div>Error: {isError.message}</div>
      ) : (
        <>
          <PrescriptionTable orders={orders} history={history} />
          <Pagination
            page={page}
            totalPages={totalPages}
            totalCount={total_count}
            onPageChange={setPage}
          />
        </>
      )}

    </div>
  );
}

export default Prescriptions;
